import { render, staticRenderFns } from "./BankInfoDefault.vue?vue&type=template&id=3a31f5f4&scoped=true"
import script from "./BankInfoDefault.vue?vue&type=script&lang=ts"
export * from "./BankInfoDefault.vue?vue&type=script&lang=ts"
import style0 from "./BankInfoDefault.vue?vue&type=style&index=0&id=3a31f5f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31f5f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a31f5f4')) {
      api.createRecord('3a31f5f4', component.options)
    } else {
      api.reload('3a31f5f4', component.options)
    }
    module.hot.accept("./BankInfoDefault.vue?vue&type=template&id=3a31f5f4&scoped=true", function () {
      api.rerender('3a31f5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/BankInfoDefault.vue"
export default component.exports